import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Toast } from 'ngx-toastr';

@Component({
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class ToastComponent extends Toast implements OnInit {
  public iconName: string;
  public mainColor: string;

  public ngOnInit() {
    this.setAppearance();
  }

  public get type(): string {
    return this.toastPackage.toastType;
  }

  public get closable(): boolean {
    return this.toastPackage.config.closeButton;
  }

  public close(): void {
    this.remove();
  }

  public getAriaLive(): string {
    switch (this.type) {
      case 'toast-success':
      case 'toast-info':
        return 'polite';
      case 'toast-warning':
      case 'toast-error':
        return 'assertive';
      default:
        return 'polite';
    }
  }

  private setAppearance(): void {
    switch (this.type) {
      case 'toast-success':
        this.iconName = 'check-thin';
        this.mainColor = 'green';
        break;
      case 'toast-warning':
        this.iconName = 'info-thin';
        this.mainColor = 'orange';
        break;
      case 'toast-error':
        this.iconName = 'warning-thin';
        this.mainColor = 'red';
        break;
      case 'toast-info':
      default:
        this.iconName = 'info-thin';
        this.mainColor = 'blue';
        break;
    }
  }
}
